import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ToastItem, ToastType } from './toast.model';

function uid() {
  return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  private readonly _toasts$ = new BehaviorSubject<ToastItem[]>([]);
  readonly toasts$ = this._toasts$.asObservable();

  show(type: ToastType, message: string, opts?: { title?: string; durationMs?: number }) {
    const durationMs = Math.max(1500, Math.min(15000, opts?.durationMs ?? 3800));
    const toast: ToastItem = {
      id: uid(),
      type,
      title: opts?.title,
      message,
      createdAt: Date.now(),
      durationMs
    };
    const next = [toast, ...this._toasts$.value].slice(0, 4);
    this._toasts$.next(next);
    window.setTimeout(() => this.dismiss(toast.id), durationMs);
    return toast.id;
  }

  success(message: string, title = 'Success') {
    return this.show('success', message, { title });
  }
  error(message: string, title = 'Error') {
    return this.show('error', message, { title, durationMs: 5200 });
  }
  warning(message: string, title = 'Warning') {
    return this.show('warning', message, { title, durationMs: 4800 });
  }
  info(message: string, title = 'Info') {
    return this.show('info', message, { title });
  }

  dismiss(id: string) {
    const next = this._toasts$.value.filter(t => t.id !== id);
    if (next.length !== this._toasts$.value.length) this._toasts$.next(next);
  }

  clear() {
    this._toasts$.next([]);
  }
}

